(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
  const updateLabels = () => {
    document.querySelectorAll('[data-gm-quantity-label]').forEach((label) => {
      const scope = label.closest('[id^="shopify-section-"]') || document;
      const selected = scope.querySelector('.ank-bundle-item.active');
      const isBundle = selected
        ? selected.dataset.type === 'bundle2' || selected.dataset.type === 'bundle3' || selected.dataset.value === '3 Clip'
        : label.dataset.defaultBundle === 'true';
      const text = isBundle ? label.dataset.bundleLabel : label.dataset.singleLabel;
      if (label.textContent !== text) label.textContent = text;
      if (label.hasAttribute('data-gm-quantity-standalone')) label.classList.toggle('sr-only', !isBundle);
    });
  };
  const start = () => {
    updateLabels();
    new MutationObserver((changes) => {
      if (changes.some((change) =>
        change.type === 'childList' ||
        (change.target.matches && change.target.matches('.ank-bundle-item'))
      )) updateLabels();
    }).observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['class']});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gm-gift-purchase-info"] && !Shopify.designMode) return;
  try {
    function gmGiftRecipientLimits(recipient) {
    if (!recipient.closest('.shopify-section')?.querySelector('.gm-gift-purchase-info')) return;
    const checkbox = recipient.querySelector('input[type="checkbox"]');
    const email = recipient.querySelector('input[type="email"]');
    const name = recipient.querySelector('input[name="properties[Recipient name]"]');
    const date = recipient.querySelector('input[type="date"]');
    const active = Boolean(checkbox?.checked);
    if (email) email.required = active;
    recipient.querySelectorAll('.recipient-fields input, .recipient-fields textarea, input[name="properties[__shopify_offset]"]').forEach(field => {
      field.disabled = !active;
    });
    const fields = recipient.querySelector('.recipient-fields');
    if (fields && !recipient.gmGiftResetObserver) {
      recipient.gmGiftResetObserver = new MutationObserver(() => gmGiftRecipientLimits(recipient));
      recipient.gmGiftResetObserver.observe(fields, { attributes: true, attributeFilter: ['class'] });
    }
    if (name) name.maxLength = 255;
    if (date) {
      const today = new Date();
      const latest = new Date(today);
      latest.setDate(latest.getDate() + 90);
      const localDate = value => `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
      date.min = localDate(today);
      date.max = localDate(latest);
    }
  }
  document.querySelectorAll('recipient-form').forEach(gmGiftRecipientLimits);
  document.addEventListener('change', event => {
    const recipient = event.target.closest('recipient-form');
    if (recipient) gmGiftRecipientLimits(recipient);
  });
  } catch(e) { console.error(e); }
})();

})();
